import { Switch } from '@thanx/uikit/switch'
import CustomerCountBadge from 'components/CustomerCountBadge'

interface SegmentFiltersHeaderProps {
  estimatedCount?: number
  onViewClick?: () => void
}

const SegmentFiltersHeader = ({
  estimatedCount,
  onViewClick,
}: SegmentFiltersHeaderProps) => {
  const hasEstimatedCount = estimatedCount !== undefined

  return (
    <div className="thanx-ai-segment-visualization__filters-header">
      <div className="thanx-ai-segment-visualization__filters-label">
        FILTERS CREATED
      </div>
      <Switch condition={hasEstimatedCount}>
        <CustomerCountBadge count={estimatedCount!} onViewClick={onViewClick} />
      </Switch>
    </div>
  )
}

export default SegmentFiltersHeader
